export const namespace = "tablet/";
export const SET_MODAL = "SET_MODAL";


